module.exports = __webpack_public_path__ + "media/images/flags/32/Norway-64c42550321cfc713fe6149ee42edb11.png";